export const bodTotalPercent = (bod: { [key: string]: string }) => {
  let totalBodPercent = 0;
  Object.keys(bod).forEach((bodKey) => {
    if (bod[bodKey].trim() !== "") {
      totalBodPercent += Number(bod[bodKey]);
    }
  });
  return totalBodPercent;
};
